module.exports = __webpack_public_path__ + "img/zhibo@2x.06790a0f.png";